import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './images/card-1-tip.png'
import _imports_1 from './images/icon-left-arrow.png'
import _imports_2 from './images/icon-right-arrow.png'


const _withScopeId = n => (_pushScopeId("data-v-52d21d6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-4" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-52d21d6e><span class=\"strong\" data-v-52d21d6e>원더플 피플을</span>  위한 리워드 </div><div class=\"desc\" data-v-52d21d6e><div data-v-52d21d6e> 보다 많은 양의 투명 음료 페트병이<br class=\"d-block d-md-none\" data-v-52d21d6e> 잘 재활용될 수 있게 하는 것이 우리의 목표예요.<br data-v-52d21d6e> 올바른 방법으로 제로웨이스트 박스를 가득 채워주신<br class=\"d-block d-md-none\" data-v-52d21d6e> 원더플 피플 개인과 단체에 <span class=\"strong\" data-v-52d21d6e>코카-콜라 보랭 캠핑의자</span>를 드려요!<br class=\"d-block d-md-none\" data-v-52d21d6e></div></div>", 2)
const _hoisted_5 = { class: "box-card" }
const _hoisted_6 = { class: "card card-1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "개인")
], -1))
const _hoisted_8 = { class: "card-image" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "d-none d-md-block img-tip"
}, null, -1))
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"card-desc\" data-v-52d21d6e><span class=\"desc-title\" data-v-52d21d6e> </span><span class=\"desc-title\" data-v-52d21d6e>개인 1개 제공</span><span class=\"desc-title\" data-v-52d21d6e> </span><div class=\"line\" data-v-52d21d6e></div><span data-v-52d21d6e>2박스 모두 올바른 방법으로</span><span data-v-52d21d6e>캠페인에 끝까지 참여한 원더플 피플</span><span class=\"strong\" data-v-52d21d6e>(개인 참여자)에게 드려요!</span></div>", 1)
const _hoisted_12 = { class: "card card-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "단체")
], -1))
const _hoisted_14 = { class: "card-image" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"card-desc\" data-v-52d21d6e><span class=\"desc-title\" data-v-52d21d6e>팀별 코카-콜라 보랭 캠핑의자 2개/</span><span class=\"desc-title\" data-v-52d21d6e>콬따 2개씩 제공</span><span class=\"desc-title\" data-v-52d21d6e>(6박스 신청한 팀 = 의자 3개 콬따 4개 제공)</span><div class=\"line\" data-v-52d21d6e></div><span data-v-52d21d6e>4박스 모두 올바른 방법으로</span><span data-v-52d21d6e>캠페인에 끝까지 참여한 원더플 피플</span><span class=\"strong\" data-v-52d21d6e>(단체 참여자)에게 드려요!</span></div>", 1)
const _hoisted_17 = { class: "page-desc" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" 코카-콜라 보랭 캠핑의자 "),
  /*#__PURE__*/_createElementVNode("span", { class: "strong" }, "TIP")
], -1))
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "strong" }, "코카-콜라 보랭 캠핑의자"),
    /*#__PURE__*/_createTextVNode(" 에 앉아 상쾌한 여유를 즐겨보세요.")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "좋아하는 간식 그리고 음료를 보관할 수 있는 보랭 가방이 부착되어 있답니다!"),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createElementVNode("div", { class: "color" }, [
    /*#__PURE__*/_createElementVNode("span", null, "(환경을 위해 캠핑 후 남은 쓰레기는 다시 보랭 가방에 넣어 "),
    /*#__PURE__*/_createElementVNode("span", null, "집으로 가져와 주세요. 올바른 분리배출도 잊지 않기로 해요.)")
  ])
], -1))
const _hoisted_21 = { class: "carousel-wrapper" }
const _hoisted_22 = { class: "carousel-content" }
const _hoisted_23 = { class: "thumbnail-wrapper" }
const _hoisted_24 = {
  class: "d-inline-flex justify-content-center",
  style: {"width":"100%"}
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "mask" }

import { TImage as TCarouselImage } from '@/components/carousel.vue';
  import { reactive, ref } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const carouselRef = ref();
  const carouselImages = reactive<TCarouselImage[]>([
    { imageUrl: require('./images/banner-1.jpg') },
    { imageUrl: require('./images/banner-2.jpg') },
    { imageUrl: require('./images/banner-3.jpg') },
    { imageUrl: require('./images/banner-4.jpg') },
  ]);

  const carouselCurrent = ref(0);

  function handleCarouselChange(e: any) {
    carouselCurrent.value = e.to;
  }


return (_ctx: any,_cache: any) => {
  const _component_AppCarousel = _resolveComponent("AppCarousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("img", {
              src: require('./images/card-1.jpg')
            }, null, 8, _hoisted_10)
          ]),
          _hoisted_11
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("img", {
              src: require('./images/card-2.png')
            }, null, 8, _hoisted_15)
          ]),
          _hoisted_16
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("img", {
          src: require('./images/card-1.jpg')
        }, null, 8, _hoisted_19),
        _hoisted_20
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_AppCarousel, {
            ref_key: "carouselRef",
            ref: carouselRef,
            images: _unref(carouselImages),
            "hidden-dot": "",
            interval: false,
            onChange: handleCarouselChange
          }, null, 8, ["images"]),
          _createElementVNode("img", {
            src: _imports_1,
            class: "control left",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (carouselRef.value.slidePrev && carouselRef.value.slidePrev(...args)))
          }),
          _createElementVNode("img", {
            src: _imports_2,
            class: "control right",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (carouselRef.value.slideNext && carouselRef.value.slideNext(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(carouselImages), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "item",
                onClick: ($event: any) => (carouselRef.value.handleSlideTo(index))
              }, [
                _createElementVNode("img", {
                  src: item.imageUrl,
                  class: "thumbnail"
                }, null, 8, _hoisted_26),
                _withDirectives(_createElementVNode("div", _hoisted_27, null, 512), [
                  [_vShow, index !== carouselCurrent.value]
                ])
              ], 8, _hoisted_25))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})